// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "styles" + "." + "ae59b63c3974f9d56914" + ".css";
};